export class IWorkWindow {
    startTime: Date;
    endTime: Date;
    isBreak: boolean;
    batchId: number;

    constructor(data: any) {
        this.batchId = data.batchId;
        this.startTime = new Date(data.startDatetime);
        this.endTime = new Date(data.endDatetime);
        this.isBreak = data.isBreak;
    }
}

export interface IDisplayedWorkWindow {
    missionGroupId?: number;
    schedule: {
        startTime: Date;
        endTime: Date;
    }[];
    batchId: number;
}
